import { Component, OnInit } from '@angular/core';
import { CategoryService } from 'src/app/services/category.service';
import { Category } from 'src/app/models/category';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss']
})
export class CategoriesComponent implements OnInit {
  public loadedCategories:boolean=false;
  public categories:Category[];
  public paginatedCategories = new BehaviorSubject<any>(null);
  private perPage=20;

  constructor(
    private _categories: CategoryService,
    private _router: Router
  ) { }

  public getCategories(page){
    this._categories.getPaginatedCategories(page, this.perPage).subscribe(paginatedData => {
      this.paginatedCategories.next(paginatedData);
      this.loadedCategories=true;
    });
  }

  public addNewCategory(){
    if(!confirm('Confirm that you want to add a new Category.')) return false;
    this._categories.addNewCategory().subscribe((res:any)=>{
      if(res.id) this._router.navigate([`/categories/${res.id}`]);
    });
  }

  pageChanged(data){
    this.perPage=data.pageSize;
    this.getCategories(data.pageIndex+1);
  }

  perPageChanged(data){
    this.perPage=data.pageSize;
    this.getCategories(1);
  }

  ngOnInit() {
    this.getCategories(1);
  }

}
